import { FC } from 'react'
import cn from 'classnames'

import useMessenger from '@/hooks/useMessenger'
import useDebounce from '@/hooks/useDebounce'
import { MESSAGE_TYPES } from '@/context/constants'
import { IAction, IMessage, IMessageItem } from '@/context/types'

import ChatBubble from '../ChatBubble'

import './styles.css'

interface ListTypeProps {
  message: IMessage
  direction: 'left' | 'right'
}

const ListType: FC<ListTypeProps> = ({ message, direction }) => {
  const { sendMessage, getConfig, getSelectedConversation, isConversationNew } =
    useMessenger()

  const handleOnClick = (actions: IAction[]) => {
    if (actions.length === 0) {
      return
    }

    const { text, payload } = actions[0]

    const sendPayload = {
      type: MESSAGE_TYPES.MESSAGE,
      conversationId: getSelectedConversation(),
      author: {
        type: getConfig()?.userType,
        userExternalId: getConfig()?.userExternalId,
      },
      content: {
        type: 'text',
        text,
        payload,
      },
      metadata: {
        source: 'poplar-messenger',
      },
    }

    sendMessage(sendPayload)
  }

  return (
    <>
      {message?.metadata?.title && (
        <pre className="pmui-font-eina03 sm:pmui-text-xs md:pmui-text-sm">
          {message.metadata.title}
        </pre>
      )}
      <ChatBubble direction={direction}>
        {message.content?.items?.map((item: IMessageItem, index: number) => (
          <div key={`${message.id}-${item.title}`}>
            <button
              className={cn(
                'pmui-font-semibold sm:pmui-text-xs md:pmui-text-sm pmui-font-eina03',
                'pmui-py-3 pmui-text-left hover:pmui-underline',
                { 'pmui-cursor-pointer': isConversationNew },
              )}
              disabled={!isConversationNew}
              onClick={useDebounce(
                () => handleOnClick(item.actions),
                getConfig()?.debounceTimeout,
              )}
            >
              {item.title}
            </button>
            {index < message.content.items.length - 1 && (
              <div className="horizontal-divider" />
            )}
          </div>
        ))}
      </ChatBubble>
    </>
  )
}

export default ListType
